import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import type { ReactElement, ReactNode } from 'react';
import type { CategoryColor } from '../../../../themes/v2/theme';
import Chip, { type ChipProps } from '../Chip/Chip';
import ChipLabel from './components/ChipLabel';
import {
  type LabeledChipAppearance,
  getLabeledChipAppearanceStyles,
  getLabeledChipBaseStyles,
} from './labeledChip.styles';

export interface LabeledChipProps {
  content: ReactNode;
  color?: CategoryColor;
  label?: string;
  icon?: ReactElement;
  appearance?: LabeledChipAppearance;
  disabled?: boolean;
  tooltip?: ReactNode;
  title?: string;
  sx?: ChipProps['sx'];
  className?: string;
  testId?: string;
}

const LabeledChip = ({
  content,
  color,
  label,
  icon,
  appearance = 'default',
  disabled,
  tooltip,
  title,
  sx,
  className,
  testId,
}: LabeledChipProps) => {
  const badge =
    color && label ? <ChipLabel color={color} label={label} appearance={appearance} /> : undefined;

  return (
    <Tooltip TooltipContent={tooltip}>
      <Chip
        label={content}
        color="secondary"
        size="small"
        disabled={disabled}
        title={title}
        className={className}
        testId={testId}
        icon={badge ?? icon}
        sx={[
          (theme) => getLabeledChipBaseStyles(theme, !badge && !!icon),
          (theme) => getLabeledChipAppearanceStyles(theme, appearance),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      />
    </Tooltip>
  );
};

export default LabeledChip;
